import * as betgalaxy from './Overview.styles.betgalaxy';
import * as betprofessor from './Overview.styles.betprofessor';
import * as betroyale from './Overview.styles.betroyale';
import * as buffalobet from './Overview.styles.buffalobet';
import * as fiestabet from './Overview.styles.fiestabet';
import * as forsport from './Overview.styles.forsport';
import * as goldenrush from './Overview.styles.goldenrush';
import * as juicybet from './Overview.styles.juicybet';
import * as junglebet from './Overview.styles.junglebet';
import * as oldgill from './Overview.styles.oldgill';
import * as puntcity from './Overview.styles.puntcity';
import * as puntgenie from './Overview.styles.puntgenie';
import * as questbet from './Overview.styles.questbet';
import * as sterlingparker from './Overview.styles.sterlingparker';
import * as sugarcastle from './Overview.styles.sugarcastle';
import * as vikingbet from './Overview.styles.vikingbet';
import * as volcanobet from './Overview.styles.volcanobet';
import * as wellbet from './Overview.styles.wellbet';
import * as titanbet from './Overview.styles.titanbet';
import * as slambet from './Overview.styles.slambet';
import * as gigabet from './Overview.styles.gigabet';
import * as betstride from './Overview.styles.betstride';
import * as templebet from './Overview.styles.templebet';
import * as goldenbet888 from './Overview.styles.goldenbet888';
import * as hyperbet from './Overview.styles.hyperbet';
import * as bet777 from './Overview.styles.bet777';
import * as chromabet from './Overview.styles.chromabet';
import * as bet575 from './Overview.styles.bet575';
import * as betblast from './Overview.styles.betblast';
import * as pyramidbet from './Overview.styles.pyramidbet';
import * as magnumbet from './Overview.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  buffalobet,
  fiestabet,
  forsport,
  goldenrush,
  juicybet,
  junglebet,
  oldgill,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  sugarcastle,
  vikingbet,
  volcanobet,
  wellbet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
